module.exports = __webpack_public_path__ + "img/bevill-state-logo.a38120e8.jpg";